// external deps
import React, { useState, useEffect } from "react";
import { Navbar } from 'ypf-pas-general-ui-components';

// internal deps
import ModalUserProfile from "../Modals/ModalUserProfile";
import ModalInfo from "../Modals/ModalInfo";
import useApp from "../../hooks/useApp";
import { getItemStorage } from "../../utils/utils";
import { constantsSession } from "../../constants/constants";
import {
  postStartChatbotRound,
  postChatbotQuestion,
} from "../../services/administrationService";
import useUserPermisions from "../../hooks/useUserPermisions";
import useUserProfile from "../../hooks/useUserProfile";
import { URL_SERVICIOS } from "../../constants/host";
import StatusReferenceModal from '../StatusReferenceModal/StatusReferenceModal';

const NavBar = () => {
  const { userInfo, onLogOut } = useApp();
  const { handlePermissions, userPermissions } = useUserPermisions();
  const {
    canBeEditMeProfileValue,
    handleRedirectToMeProfile,
    handleGetInfoUserLogger,
    infoUserLogger,
    showModalInfo,
    setShowModalInfo
  } = useUserProfile();
  const [userRol, setUserRol] = useState("");
  const [roles, setRoles] = useState([]);
  const [idChat, setIdChat] = useState(null);

  
  // to show modal user profile
  
  const [showModalUserProfile, setShowModalUserProfile] = useState(false);

  // get user credentials
    const accessToken = getItemStorage(constantsSession.ACCESS_TOKEN, false);
    const expireIn = getItemStorage(
      constantsSession.ACCESS_TOKEN_EXPIRE_IN,
      false
    );
    const refreshToken = getItemStorage(constantsSession.REFRESH_TOKEN, false);
    const accessTokenDate = getItemStorage(
      constantsSession.ACCESS_TOKEN_DATE,
      false
    );

  //to see the color reference Modal
  const [showModal, setShowModal] = useState(false);

  const activeModal = (modal) => {
    setShowModal((state) => ({ ...state, [modal]: true }));
  };
  const hideModal = () => {
    setShowModal(false);
  };
  const activeStatusReference = () => {
    activeModal('statusReferenceModal');
  };
  // IMPORTANT
  // this function will need to be created inside the UI Kit, in the Navbar component
  // the Navbar will only receive an array of roles

  const validUserRol = (activeRoles) => {
    if (activeRoles.length > 0) {
      setUserRol(activeRoles.map((rol) => rol.nombre.substring(8)));
    } else {
      setUserRol("-");
    }
  };
  // callback to the chatbot
  const postMessage = async (message) => {
    const msg = { question: message };
    const isFirstChat = !idChat;

    return new Promise((resolve, reject) => {
      const promise = !isFirstChat
        ? postChatbotQuestion(msg, idChat)
        : postStartChatbotRound(msg);

      promise
        .then(({ data }) => {
          if (isFirstChat) {
            setIdChat(data.chatId);
          }
          resolve({ message: data.response });
        })
        .catch((err) => reject(err));
    });
  };

  useEffect(() => {
    if (roles && roles.length > 0) {
      validUserRol(roles);
      handlePermissions();   
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles]);

  useEffect(() => {
    const userRoles = getItemStorage(constantsSession.ROLES_ME);
    setRoles(userRoles || []);
  }, [userInfo]);

  useEffect(()=>{
    // Only have permission to edit profile show button and get info profile
    if(Object.keys(userPermissions).length !== 0){
      const changeContentModalInfo = !userPermissions?.userProfile?.canEditMeProfile;
      handleGetInfoUserLogger(changeContentModalInfo);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[userPermissions])

  return (
    <>
       <Navbar
      chatbotPostMessage={postMessage}
      chatbotTyC={`${URL_SERVICIOS}/termsofservice/?at=${accessToken}&ei=${expireIn}&rt=${refreshToken}&atd=${accessTokenDate}`}
      expand="lg"
      user={userInfo}
      onLogOut={onLogOut}
      showMenu={false}
      logoYclickActive
      manyUserRoles={userRol}
      showButtonHelp
      showChatbot
      showUserProfile
      onViewProfile={() => setShowModalUserProfile(true)}
      openModalReference={activeStatusReference}
    />
    {showModalUserProfile && (
       <ModalUserProfile
       showModalUserProfile={showModalUserProfile}
       setShowModalUserProfile={setShowModalUserProfile}
       canBeEditMeProfile={canBeEditMeProfileValue}
       infoUserLogger={infoUserLogger}
       primaryAction={() => {
         handleRedirectToMeProfile(infoUserLogger);
         setShowModalUserProfile(false);
       }}
     />
    )}
    {showModalInfo.show && (
      <ModalInfo
      title="Falta completar perfil"
      showModalInfo={showModalInfo.show}
      setShowModalInfo={setShowModalInfo}
      primaryActionLabel="Revisar datos"
      primaryAction={() => {
        handleRedirectToMeProfile(infoUserLogger);
        setShowModalInfo(false);
      }}
      secondaryActionLabel={"Salir"}
      secondaryAction={()=> onLogOut()}
      primaryActionDisabled={showModalInfo.changeContentModalInfo}
      strongMessage={showModalInfo.strongMessage}
      spanMessage={showModalInfo.spanMessage}

    />
    )}
    <StatusReferenceModal onHide={hideModal} show={showModal} />
    </>
 
  );
};

export default NavBar;
